import dayjs from 'dayjs'
import React, { type ReactElement } from 'react'

export type DateTimeCellProps = {
  style?: object
  value: string
}

export default function DateTimeCell({
  style,
  value
}: DateTimeCellProps): ReactElement {
  return <div style={style}>{dayjs(value).format('DD-MM-YYYY HH:mm')}</div>
}
